import React, { useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

/**
 * Dark mode toggle. Persists preference to localStorage and applies
 * the `dark` class on <html> which flips shadcn/Tailwind CSS variables.
 */
export default function ThemeToggle() {
  const [dark, setDark] = useState(() => {
    if (typeof window === "undefined") return false;
    const saved = localStorage.getItem("ruleai_theme");
    if (saved) return saved === "dark";
    return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (dark) root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("ruleai_theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <button
      onClick={() => setDark(!dark)}
      data-testid="theme-toggle"
      className="w-9 h-9 rounded-sm border border-border grid place-items-center hover:bg-secondary transition-colors"
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      title={dark ? "Light mode" : "Dark mode"}
    >
      {dark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  );
}
